module.exports = __webpack_public_path__ + "static/media/landing-man.f5300b58.png";